import { Navigate, Outlet, Routes, Route, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import VendorListingPage from "./components/vendor/vendorList";
import VendorViewPage from "./components/vendor/vendorView";
import { VendorCreate } from "./components/vendor/vendor-create";
import { TransactionView } from "./components/transaction/TransactionView";
import "./App.css";
import TransactionListingPage from "./components/transaction/transactionList";
import HelpQuestions from "./components/common/help";
import ReportPage from "./components/report/report";
import { DashboardPage } from "./components/Dashboard/Dashboard.jsx";
import { PurchaseOrderCreate } from "./components/PurchaseOrder/po-create.js";
import { PurchaseOrderView } from "./components/PurchaseOrder/POV.jsx";
import PurchaseListingPage from "./components/PurchaseOrder/purchase-list.jsx";
import { TransactionCreate } from "./components/transaction/transaction-create.js";
import ProductListingPage from "./components/Product/product-list.jsx";
import { CreateProduct } from "./components/Product/CreateProduct.jsx";
import { ProjectList } from "./components/setup/project/projectList.jsx";
import { CreateProject } from "./components/setup/project/createProject.jsx";
import { ViewProject } from "./components/setup/project/viewProject.jsx";
import { ViewProduct } from "./components/Product/ViewProduct.jsx";
import { PurchaseQuotationView } from "./components/purchase-quotation/purchase-quotation-view.js";
import { PurchaseRequestView } from "./components/purchase-request/purchase-request-view.js";
import { PurchaseRequestCreate } from "./components/purchase-request/purchase-request-create.js";
import PurchaseReqListingPage from "./components/purchase-request/purchase-request-list.jsx";
import { PurchaseQuotationCreate } from "./components/purchase-quotation/purchase-quotation-create.js";
import VendorHistoryListPage from "./components/vendorHistory/vendor-history-list.jsx";
import PurchaseQuotationListPage from "./components/purchase-quotation/purchase-quotation-list.jsx";
import { useEffect, useState } from "react";
import { useGlobal } from "./GlobalContext.js";
import UnAuthorized from "./components/common/unauthorized.js";
import ProjectNewList from "./components/setup/project/projectNewList.jsx";
import { apiCallAdmin } from "./services/api-service.js";

//Payment
import PaymentListingPage from "./components/Payment/paymentList.jsx";
import PaymentCreate from "./components/Payment/paymentCreate.jsx";
import PaymentView from "./components/Payment/paymentView.jsx";
import PaymentHistoryListingPage from "./components/Payment/paymenthistoryList.jsx";
import { getOrgLogoApi } from "./components/common/common-api.js";
import PoweredBy from "./components/common/powered-by.jsx";
import BankTransactionListingPage from "./components/Bank_Transaction/bank-trans-list.jsx";

function App() {
  const location = useLocation();
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;

  const { rolePermissionList, setRolePermissionList, setUserType, setNumberType, setOrgImage } =
    useGlobal();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkToken = async () => {
      try {
        console.log("🔍 Checking token validity...");

        const response = await apiCallAdmin("get", "validatetoken");

        console.log("✅ Token status:", response.status);

        if (response.status === 401) {
          handleInvalidToken();
        }
      } catch (err) {
        console.error("❌ Token validation failed:", err);
        handleInvalidToken();
      }
    };

    const handleInvalidToken = () => {
      const currentURL = window.location.href;

      const redirectData = {
        redirectPath: currentURL,
        app: "vendor",
        ts: Date.now(),
      };

      console.warn("🔐 Saving redirect in window.name:", redirectData);

      // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
      window.name = JSON.stringify(redirectData);

      console.log("📌 window.name set:", window.name);

      // Clear token
      document.cookie =
        "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      console.log("➡️ Redirecting to login:", `${accountsUrl}/login`);
      // window.location.href = `${accountsUrl}/login`;
    };

    // 🔥 IMPORTANT: run once on load
    console.log("🚀 Initial token check");
    checkToken();

    // Recheck when tab regains focus
    const onFocus = () => {
      console.log("👁 Window focused → rechecking token");
      checkToken();
    };

    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);
  }, []);

  useEffect(() => {
    initializeAppData();
    getOrgLogo();
  }, []);

  const initializeAppData = async () => {
    await Promise.allSettled([getRolePermission(), getCountryDetails()]);
    setLoading(false);
  };

  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        setOrgImage(response.image ?? "");
      }

    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  useEffect(() => {
    const channel = new BroadcastChannel(`auth_channel_mawalog_${environment}`);

    channel.onmessage = () => {
      window.location.reload();
    };

    return () => channel.close();
  }, []);





  const getRolePermission = async () => {
    try {
      const response = await apiCallAdmin("get", "get_role_permission/8");

      if (response.status === 200 && response.data.success) {
        setUserType(response.data.user_type);
        setRolePermissionList(response.data.role_permission ?? []);
        localStorage.setItem(
          "rolePermissionList",
          JSON.stringify(response.data.role_permission ?? [])
        );
        localStorage.setItem("userType", response.data.user_type ?? "");
      } else {
        setRolePermissionList([]);
      }
    } catch (err) {
      console.error("Role permission error:", err);
    }
  };
  const COUNTRY_LOCALE_MAP = {
    IN: "en-IN",
    US: "en-US",
    UK: "en-GB",
    AE: "en-AE",
  };
  function getCountryCode(country) {
    return country?.split("-")[0] || "US";
  }

  const getCountryDetails = async () => {
    try {
      const response = await apiCallAdmin("get", "profile");

      if (response.status === 200 && response.data.success) {
        const user = response.data.user;

        // 1️⃣ Extract country code (IN)
        const countryCode = getCountryCode(user.country);

        // 2️⃣ Resolve locale
        const locale =
          COUNTRY_LOCALE_MAP[countryCode] || "en-US";

        // 3️⃣ Save in state
        setNumberType(locale);

        // 4️⃣ Save in localStorage (Zoho-style)
        localStorage.setItem("userLocale", locale);

      }
    } catch (err) {
      console.error("Country detail error:", err);
    }
  };


  const ProtectedRoute = ({ isAllowed }) =>
    isAllowed ? <Outlet /> : <Navigate to="/unauthorized" />;

  const checkPermission = (menuName, permission) =>
    rolePermissionList.some(
      (item) =>
        item.name === menuName &&
        item.menu_permission &&
        item[permission] === true
    );

  /* ---------------------------------
   * TOKEN CHECK + ZOHO STYLE REDIRECT
   * --------------------------------- */

  /** ----------------------------
   *   ROUTES
   * ----------------------------- */

  return (
    <>
      {loading ? (
        <p></p>
      ) : (
        <>

          <Routes>
            <Route path="/payment/create" element={<PaymentCreate />} />
            <Route path="/payment/view" element={<PaymentView />} />
            <Route path="/payment" element={<PaymentListingPage />} />
            <Route path="/payment/history" element={<PaymentHistoryListingPage />} />
            <Route path="/unauthorized" element={<UnAuthorized />} />

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Dashboard", "menu_permission")}
                />
              }
            >
              <Route path="/" element={
                <DashboardPage />
              } />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Vendors", "list_permission")}
                />
              }
            >
              <Route path="/vendor" element={<VendorListingPage />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Vendors", "create_permission")}
                />
              }
            >
              <Route path="/vendor/create" element={<VendorCreate />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Transactions", "list_permission")}
                />
              }
            >
              <Route path="/transaction" element={<TransactionListingPage />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Transactions", "view_permission")}
                />
              }
            >
              <Route path="/viewTransaction" element={<TransactionView />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Transactions", "create_permission")}
                />
              }
            >
              <Route path="/transaction/create" element={<TransactionCreate />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Vendors", "view_permission")}
                />
              }
            >
              <Route path="/viewVendor" element={<VendorViewPage />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Purchase Order", "list_permission")}
                />
              }
            >
              <Route path="/purchase-order" element={<PurchaseListingPage />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Report", "menu_permission")}
                />
              }
            >
              <Route path="/report" element={<ReportPage />} />
            </Route>

            <Route path="/help" element={<HelpQuestions />} />

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission(
                    "Purchase Order",
                    "create_permission"
                  )}
                />
              }
            >
              <Route path="/po/create" element={<PurchaseOrderCreate />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Purchase Order", "view_permission")}
                />
              }
            >
              <Route path="/po/view" element={<PurchaseOrderView />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Products", "list_permission")}
                />
              }
            >
              <Route path="/product" element={<ProductListingPage />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Products", "create_permission")}
                />
              }
            >
              <Route path="/product/create" element={<CreateProduct />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Project", "create_permission")}
                />
              }
            >
              <Route path="/project" element={<ProjectNewList />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Products", "view_permission")}
                />
              }
            >
              <Route path="/product/view" element={<ViewProduct />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={
                    checkPermission("Project", "menu_permission") ||
                    checkPermission("Industry", "menu_permission") ||
                    checkPermission("Sub Industry", "menu_permission") ||
                    checkPermission("Product Group", "menu_permission") ||
                    checkPermission("Vendor Grade", "menu_permission")
                  }
                />
              }
            >
              <Route path="/setup" element={<ProjectList />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Project", "create_permission")}
                />
              }
            >
              <Route path="/project/create" element={<CreateProject />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Project", "view_permission")}
                />
              }
            >
              <Route path="/project/view" element={<ViewProject />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission(
                    "Purchase Request",
                    "view_permission"
                  )}
                />
              }
            >
              <Route path="/pr/view" element={<PurchaseRequestView />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission(
                    "Purchase Quotation",
                    "view_permission"
                  )}
                />
              }
            >
              <Route path="/pq/view" element={<PurchaseQuotationView />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission(
                    "Purchase Request",
                    "view_permission"
                  )}
                />
              }
            >
              <Route path="/pr" element={<PurchaseReqListingPage />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission(
                    "Purchase Request",
                    "create_permission"
                  )}
                />
              }
            >
              <Route path="/pr/create" element={<PurchaseRequestCreate />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission(
                    "Purchase Quotation",
                    "create_permission"
                  )}
                />
              }
            >
              <Route path="/pq/create" element={<PurchaseQuotationCreate />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission("Vendor History", "list_permission")}
                />
              }
            >
              <Route path="/vendor-history" element={<VendorHistoryListPage />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={
                    checkPermission("Bank Transaction", "list_permission") || true
                  }
                />
              }
            >
              <Route path="/bank-transaction" element={<BankTransactionListingPage />} />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAllowed={checkPermission(
                    "Purchase Quotation",
                    "list_permission"
                  )}
                />
              }
            >
              <Route
                path="/purchase-quotation"
                element={<PurchaseQuotationListPage />}
              />
            </Route>
          </Routes>

          {location.pathname !== "/help" && <PoweredBy />}

        </>
      )}
    </>
  );
}

export default App;
